import './NewArticle.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"

const NewArticle = observer(
  class NewArticle extends Component {
    
		
		state={
			geocoords:''
		}
		
		haveclicked = false;

		componentDidMount() {
      this.getGeoCoords();
			this.haveclicked = false;
			// this.props.flow.getUserById(ownerid).then(res=>this.setState({ownermail:res.email}));
		}
	
		rndstr(length) {
				var result           = '';
				var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				var charactersLength = characters.length;
				for ( var i = 0; i < length; i++ ) {
					result += characters.charAt(Math.floor(Math.random() *  charactersLength));
			 }
			 return result;
		}	
			
		// ******** GEOLocation
		

		success = (pos) => {
			this.setState({geocoords : pos.coords.latitude.toFixed(5) + ',' + pos.coords.longitude.toFixed(5)});
		}

		error = (err) => {
			this.setState({geocoords : 'notavailable'});
			// this.geocoords = 'notavailable';//console.warn(`ERROR(${err.code}): ${err.message}`);
		}		

		getGeoCoords = () => {
			var options = {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0
			};
			navigator.geolocation.getCurrentPosition(this.success, this.error, options);
		}
	
	
		saveArticle() {
			if(this.haveclicked) return true;
			let md = {};
			md.title = document.getElementById('newarttitle').value;
			md.eventcategory = document.getElementById('newarteventcategory').value;
			md.location = document.getElementById('newartlocation').value;
			// md.publishdate = new Date().toJSON().replace('T',' ').substr(0,16);
			md.publishdate = '2099-01-01 00:00';
			md.geocoords = this.state.geocoords.replace('notavailable','');
			md.reporters = this.props.userid;
			md.customid = 'a'+this.rndstr(11);
			if(md.title === '' || md.eventcategory === '' || md.location === '')
				alert("Bitte alle Felder ausfüllen!");
			else {
				this.props.flow.newDistproject('pmdb_newstv',0,md).then(res=>this.postSave(res));
				this.haveclicked = true;
			}
		}

		postSave(res) {
			this.props.cbarticlesaved(res.data.id);
		}

		render() {
			return  (
				<div>
					<div className="articleheadline">	Artikel anlegen</div>
					<div className="newartmetadatacont">
						<div className="newartmetadatarow">
							<div className="newartmetalabel">Titel: </div>
							<div className="metavalue">
								<input type="text" className="newarttextinp" id="newarttitle" />
							</div>
						</div>
						<div className="newartmetadatarow">
							<div className="newartmetalabel">Geschehen: </div>
							<select  className="newartselect" id="newarteventcategory">
								<option value="">Bitte wählen</option>
								<option value="Unfall">Unfall</option>
								<option value="Brand">Brand</option>
								<option value="Kriminalität">Kriminalität</option>
								<option value="Corona">Corona</option>
								<option value="Gesundheit">Gesundheit</option>
								<option value="Politik">Politik</option>
								<option value="Gesellschaft">Gesellschaft</option>
								<option value="Wetter">Wetter</option>
								<option value="Sonstiges">Sonstiges</option>
							</select>
						</div>
						<div className="newartmetadatarow">
							<div className="newartmetalabel">Ort: </div>
								<input type="text" className="newarttextinp" id="newartlocation" />
						</div>
						<div className="newartmetadatarow">
							<div className="newartmetalabel">Koordinaten: </div>
								<div className="newartmetareadonly" id="newartgeocoords" >
									{this.state.geocoords == 'notavailable' ? <span className="redtext">nicht verfügbar</span> : 'Nord: ' + (''+this.state.geocoords).replace(',',' Ost: ') }
								</div>
						</div>
						<button className="newartsubmitknob" onClick={()=>{ this.saveArticle() }}>Artikel anlegen</button>
					</div>
				</div>
			);
		}
		
		
  }
)


export default Flow.injectFlow(NewArticle);